// extracted by mini-css-extract-plugin
module.exports = {"input":"x_bm","input__standalone":"x_bn","label":"x_bp","labelText":"x_bq"};